
import ActionType from '../actions/ActionType'
export default (state = { completed: {} }, action) => {
    switch (action.type) {
        case ActionType.S3_MANAGER.LIST_SUCCESS:           
            return {
                ...state,
                fileList: action.payload.data,
                baseUrl:action.payload.baseUrl
            }
        default:
            return state
    }
}